import React, { Component } from 'react';
import { Table, Row, Col, Popover, PopoverBody } from 'reactstrap';
import Config from '../../Util/config';

const idUsuario = localStorage.getItem("CodUsuario");

class OpcoesDownloadItem extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			popoverOpen: false,
			icoOver: false,
			status: this.props.status,
			tipoRelatorio: false

		};
	}

	toggle = () => {
		if ((this.props.status == 'Finalizado' || this.props.status == 'ErroEstrutura'))
			this.setState({ popoverOpen: !this.state.popoverOpen });
	}

	mouseOverHandler = () => {
		this.setState({ icoOver: !this.state.icoOver });
	}

	mouseLeaveHandler = () => {
		this.setState({ icoOver: false });
	}

	opcoesRelatorio = (modulo) => {
		if (modulo == "Fiscal") {
			if (this.props.origem === 'arquivos') {
				return (
					<div className="tipos-relatorio">
						<p></p>
						<div onClick={this.relatorioInteligente}>  
							<i className="ecoico ecoico-relatorio-inteligente"></i>
							<span>Exportar Relatório Gerencial</span>
						</div>
						<div onClick={this.relatorioDivergencias}>
							<i className="ecoico ecoico-relatorio"></i>
							<span>Exportar Erros Completo</span>
						</div>
						<div onClick={this.relatorioDivergenciasAgrupado}>
							<i className="ecoico ecoico-relatorio"></i>
							<span>Exportar Erros Agrupado</span>
						</div>
					</div>
				)
			}
			else {
				return (
					<div className="tipos-relatorio">
						<div onClick={this.relatorioDivergencias}>
							<i className="ecoico ecoico-relatorio"></i>
							<span>Exportar Erros</span>
						</div>
					</div>
				)
			}
		}
		else {
			return (
				<div className="tipos-relatorio">
					<div onClick={this.relatorioDivergencias}>
						<i className="ecoico ecoico-relatorio"></i>
						<span>Exportar Erros Completo</span>
					</div>
					<div onClick={this.relatorioDivergenciasAgrupado}>
						<i className="ecoico ecoico-relatorio"></i>
						<span>Exportar Erros Agrupado</span>
					</div>
				</div>
			)
		}
	}

	relatorioInteligente = () => {
		let urlApi = this.props.moduloEfd === "Fiscal" ? Config.urls.API_URL_FISCAL : Config.urls.API_URL_CONT;
		window.location.replace(urlApi + "Relatorio/Download/" + this.props.idArquivo + "/" + idUsuario);
		this.toggle();
	}

	relatorioDivergencias = () => {
		this.setState({ tipoRelatorio: true });
		console.log(`Modulo: ${this.props.moduloEfd}`);
		window.location.replace(Config.urls.API_URL_BASE + "Exportacao/FileContentResult/" + this.props.moduloEfd + "/" + this.props.idArquivo + "/" + true);
		this.toggle();
	}

	relatorioDivergenciasAgrupado = () => {
		this.setState({ tipoRelatorio: false });
		console.log(`Modulo: ${this.props.moduloEfd}`);
		window.location.replace(Config.urls.API_URL_BASE + "Exportacao/FileContentResult/" + this.props.moduloEfd + "/" + this.props.idArquivo + "/" + false);
		this.toggle();
	}

	render() {
		return (
			<div className="opcoes-download">
				<i 
					id={'buttonOpcoesDownload-' + this.props.idArquivo} 
					className={this.state.icoOver && this.props.status == 'Finalizado' ? "ecoico ecoico-baixar-azul" : ((this.props.status != 'Finalizado') ? "ecoico ecoico-baixar-cinza disable" : "ecoico ecoico-baixar-cinza")} 
					onMouseEnter={this.mouseOverHandler} 
					onMouseLeave={this.mouseLeaveHandler} 
					onClick={this.toggle}
				></i>

				<Popover 
					placement="bottom" 
					isOpen={this.state.popoverOpen} 
					target={'buttonOpcoesDownload-' + this.props.idArquivo} 
					toggle={this.toggle}
				>
					<PopoverBody>
						{this.opcoesRelatorio(this.props.moduloEfd)}
					</PopoverBody>
				</Popover>
			</div>
		);
	}
}

export default OpcoesDownloadItem;


// WEBPACK FOOTER //
// ./src/Componente/Modulo/OpcoesDownloadItem.jsx